const filterText = (scope, key) =>
  I18n.t(key, {
    scope: `companies_overview.filters.${scope}`,
  })

export const filterTitle = (scope) => {
  return filterText(scope, 'title')
}

export const filterModalHelp = (scope) => {
  return filterText(scope, 'modal_help')
}
